import { render } from "./Megkozelites.vue?vue&type=template&id=5f462fa0&scoped=true"
import script from "./Megkozelites.vue?vue&type=script&lang=js"
export * from "./Megkozelites.vue?vue&type=script&lang=js"

import "./Megkozelites.vue?vue&type=style&index=0&id=5f462fa0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\source\\MFVK\\menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f462fa0"]])

export default __exports__